import { Icon, IconProps } from ".";

export const Cart = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M29.4731 12.4675V18.7518H27.9V20.3222H26.3296V21.8954H13.7605V23.4657H12.1873L12.1871 12.4673H10.6167V10.8969H7.47314V9.32373H12.1872V10.8969H13.7604V12.4673L29.4731 12.4675ZM10.6171 26.6068H13.7609V28.18H16.9016V26.6068H23.1859V28.18H26.3296L26.3294 26.6068H27.8998V23.4661H26.3294V25.0365H12.1875V23.4661H10.6172L10.6171 26.6068Z" />
    </Icon>
  );
};
